/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import type {
  CreateSscrSiteAssignment,
  PagedResultOfSscrSiteAssignmentSummaryDto,
  ScheduleSiteChangeRequestDto,
  SearchSscrSiteAssignmentsParams
} from '../models';

import { customInstance } from '../axios';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];


  /**
 * @summary Returns a paged list of sscrsiteassignments matching the supplied filter and sort criteria.
 */
export const searchSscrSiteAssignments = (
    params?: SearchSscrSiteAssignmentsParams,
 options?: SecondParameter<typeof customInstance<PagedResultOfSscrSiteAssignmentSummaryDto>>,) => {
      return customInstance<PagedResultOfSscrSiteAssignmentSummaryDto>(
      {url: `/deployment/sscr-site-assignments`, method: 'GET',
        params
    },
      options);
    }
  /**
 * @summary Creates a new SscrSiteAssignment from the supplied command.
 */
export const createSscrSiteAssignment = (
    createSscrSiteAssignment: CreateSscrSiteAssignment,
 options?: SecondParameter<typeof customInstance<ScheduleSiteChangeRequestDto>>,) => {
      return customInstance<ScheduleSiteChangeRequestDto>(
      {url: `/deployment/sscr-site-assignments`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: createSscrSiteAssignment
    },
      options);
    }
  /**
 * @summary Returns the SscrSiteAssignment identified by the route id.
 */
export const getSscrSiteAssignmentById = (
    id: string,
 options?: SecondParameter<typeof customInstance<ScheduleSiteChangeRequestDto>>,) => {
      return customInstance<ScheduleSiteChangeRequestDto>(
      {url: `/deployment/sscr-site-assignments/${id}`, method: 'GET'
    },
      options);
    }
  export type SearchSscrSiteAssignmentsResult = NonNullable<Awaited<ReturnType<typeof searchSscrSiteAssignments>>>
export type CreateSscrSiteAssignmentResult = NonNullable<Awaited<ReturnType<typeof createSscrSiteAssignment>>>
export type GetSscrSiteAssignmentByIdResult = NonNullable<Awaited<ReturnType<typeof getSscrSiteAssignmentById>>>
